import axios from 'axios';
import { API_ENDPOINTS } from '../../apiConfig';

export interface TaskAssignmentDTO {
  id?: string;

  tenantId?: string;
  tenantName?: string;

  entityType?: string;
  entityId?: string;
  comments?: string;
  userId?: string;
  userName?: string;
  status?: string;

  role?: string;
  assignedBy?: string;
  assignedAt?: string;

  isActive?: boolean;
  isDeleted?: boolean;

  createdBy?: string;
  updatedBy?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface FilterTaskAssignmentDTO {
  tenantId?: string;
  tenantName?: string;

  generalTaskId?: string;
  projectTaskId?: string;

  userId?: string;
  userName?: string;
  status?: string;

  role?: string;
  assignedBy?: string;
}

export interface TaskAssignmentSearchResult {
  content: TaskAssignmentDTO[];
  totalPages: number;
  totalElements: number;
  size: number;
  number: number;
  last: boolean;
  first: boolean;
}

export interface TaskAssignmentSummary {
    totalAssignments: number;
    completedAssignments: number;
    pendingAssignments: number;
    overdueAssignments: number;
  }

  export interface TaskAssignmentFilterRequest {
    tenantId: string;
    entityType?: string;
    entityId?: string;
     
  }
  
  export interface AssignedUserResponse {
    assignmentId: string;
    userId: string;
    firstName: string;
    lastName: string;
    email: string;
    isActive: boolean;
  }

const BASE_URL = `${API_ENDPOINTS.project}/task-assignments`;
 

export const TaskAssignmentApi = {
  // Create
  create: async (data: TaskAssignmentDTO): Promise<TaskAssignmentDTO> => {
    const response = await axios.post(`${BASE_URL}`, data);
    return response.data;
  },

  // Update
  update: async (id: string, data: TaskAssignmentDTO): Promise<TaskAssignmentDTO> => {
    const response = await axios.put(`${BASE_URL}/${id}`, data);
    return response.data;
  },

  // Get By ID
  getById: async (id: string): Promise<TaskAssignmentDTO> => {
    const response = await axios.get(`${BASE_URL}/${id}`);
    return response.data;
  },

  // Delete
  delete: async (id: string): Promise<void> => {
    await axios.delete(`${BASE_URL}/${id}`);
  },

  // Search (with pagination)
  search: async (
    filter: FilterTaskAssignmentDTO,
    page: number = 0,
    size: number = 10,
    sort: string = 'createdAt,desc'
  ): Promise<TaskAssignmentSearchResult> => {
    const response = await axios.post(`${BASE_URL}/search?page=${page}&size=${size}&sort=${sort}`, filter);
    return response.data;
  },

  async getSummary(): Promise<TaskAssignmentSummary> {
    const response = await axios.get<TaskAssignmentSummary>('/api/task-assignments/summary');
    return response.data;
  },
  assignUsers: async (taskId: string, userIds: string[]): Promise<TaskAssignmentDTO> => {
    const response = await axios.post(`${BASE_URL}/bulk-assignments`, {
      taskId,
      userIds,
    });
    return response.data;
  },
  bulkAssign: async (assignments: TaskAssignmentDTO[]): Promise<void> => {
    try {
      const response = await axios.post(`${BASE_URL}/bulk-assign`, assignments);
      console.log('Bulk assign response:', response.data);
    } catch (error) {
      console.error('Bulk assignment failed:', error);
      throw error;
    }
  },

  getAssignedUsers: async (
    request: TaskAssignmentFilterRequest
  ): Promise<AssignedUserResponse[]> => {
    try {
      const response = await axios.post<AssignedUserResponse[]>(
        `${BASE_URL}/assigned-users`,
        request
      );
      return response.data;
    } catch (error) {
      console.error('Failed to fetch assigned users:', error);
      throw error;
    }
  },

  
};

 